export default class ShopProductGroup extends HTMLElement {
    private open = false

    private form: HTMLFormElement
    private button: HTMLButtonElement
    private list: HTMLUListElement
    private radios: HTMLInputElement[] = []
    private labels: HTMLLabelElement[] = []

    constructor() {
        super()

        this.form = this.querySelector('[data-form]')!
        this.button = this.querySelector('[data-toggle]')!
        this.list = this.querySelector('[data-list]')!
        this.radios = Array.from(this.querySelectorAll('input[name="product_group"]'))
        this.labels = Array.from(this.querySelectorAll('label[data-label]'))

        if (this.labels && this.radios) {
            this.labels.forEach((label) => {
                label.addEventListener('click', this.handleLabelClick.bind(this))
            })
        }

        this.form.addEventListener('change', this.handleFormChange)
    }

    set isOpen(value: boolean) {
        this.open = value
        this.button.setAttribute('data-open', this.open.toString())
        this.toggle()
    }

    get isOpen() {
        return this.open
    }

    private handleFormChange = (e: Event) => {
        const target = e.target as HTMLInputElement
        const value = target.value

        const url = target.getAttribute('data-url')

        console.log('form change', url?.split('/')[url?.split('/').length - 1])

        // update the list and put the selected item in at the top
        const selectedItem = this.list.querySelector(`[data-item-value="${value}"]`)
        console.log(selectedItem)
        if (selectedItem) {
            this.list.insertBefore(selectedItem, this.list.firstChild)

            this.isOpen = false
        }

        // update URL
        setTimeout(() => {
            if (url) {
                window.location.href = url
            }
        }, 10)
    }

    private handleLabelClick = () => {
        this.isOpen = !this.isOpen
    }

    private toggle() {
        if (this.isOpen) {
            this.list.classList.add('!h-auto')
            this.button.setAttribute('aria-expanded', 'true')
            this.style.zIndex = '1'

            this.button.classList.add('rotate-180')
        } else {
            this.list.classList.remove('!h-auto')
            this.button.setAttribute('aria-expanded', 'false')
            this.list.scrollTo({ top: 0 })
            this.style.zIndex = 'unset'

            this.button.classList.remove('rotate-180')
        }
    }
}

customElements.define('shop-product-group', ShopProductGroup)
